<!--
2021-11-29 CHP 播放YouTube视频
2021-11-30 CHP 处理横、竖屏切换时的变化
-->
<template>
  <div class="js-video [vimeo, widescreen]" :style="frameStyle">
    <iframe :src="getVideoURL()" frameborder="0" allowfullscreen>
    </iframe>
    <div class="close" @click="close()">
      <span>&lt; Back</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoIframe',
  data () {
    return {
      screenHeight: 0,
      screenWidth: 0,
      frameStyle: {
      },
      videoID: ''
    }
  },
  mounted () {
    console.log(window.innerHeight)
    console.log(window.screen.availHeight)
    console.log(window.screen.height)
    console.log(document.body.clientHeight)
    console.log(window.innerWidth)

    window.addEventListener('resize', this.resizeHandler, false)

    this.screenHeight = window.innerHeight
    this.screenWidth = window.innerWidth

    let height = document.documentElement.clientHeight
    let width = document.documentElement.clientWidth
    // 2021-11-28 CHP 竖屏时进行旋转
    if (height > width) {
      this.frameStyle = {
        width: this.screenHeight + 'px',
        height: this.screenWidth + 'px',
        transform: 'rotate(90deg) translate(' +
          (this.screenHeight - this.screenWidth) / 2 + 'px,' +
          (this.screenHeight - this.screenWidth) / 2 + 'px)'
      }
    }
  },
  methods: {
    close () {
      this.$router.push('/')
    },
    getVideoURL () {
      return 'https://www.youtube.com/embed/' + this.videoID + '?enablejsapi=1&playsinline=0&controls=0'
    },
    // 2021-11-29 CHP 屏幕转换时处理
    resizeHandler () {
      let height = document.documentElement.clientHeight
      let width = document.documentElement.clientWidth
      // 横屏
      if (width > height) {
        console.log('横屏')
        this.frameStyle = {}
      } else {
        console.log('竖屏')
        this.frameStyle = {
          width: this.screenHeight + 'px',
          height: this.screenWidth + 'px',
          transform: 'rotate(90deg) translate(' +
            (this.screenHeight - this.screenWidth) / 2 + 'px,' +
            (this.screenHeight - this.screenWidth) / 2 + 'px)'
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.videoID = to.query.param
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler, false)
  }
}
</script>
<style lang="less" scoped>
.js-video {
  height: 0;
  /*padding-top: 25px;
  padding-bottom: 67.5%;
  margin-bottom: 10px;*/
  padding-bottom: 20px;
  overflow: hidden;
}

.js-video.widescreen {
  /*padding-bottom: 56.34%;*/
}

.js-video.vimeo {
  padding-top: 0;
}

.js-video embed, .js-video iframe, .js-video object, .js-video video {
  /*top: 120px;
  left: -130px;
  width: 568px;
  height: 320px;*/
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}

.close {
  background: rgb(204 185 185 / 50%);
  font-size: 14px;
  z-index: 100;
  position: absolute;
  bottom: 10px;
  left: 10px;
  padding: 5px 10px;
  color: #FFF;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/VideoIframe/index.vue